<script setup>
import AppLayout from '@/Layouts/AppLayout.vue';
import { ref } from 'vue';
import { useForm, Link } from '@inertiajs/vue3';

const props = defineProps({
    user: Object,
    year: String,
    sessions: Object,
    currentSessionId: String,
});

console.log(props.currentSessionId);

const passwordInput = ref(null);
const currentPasswordInput = ref(null);

const form = useForm({
    current_password: '',
    password: '',
    password_confirmation: '',
});

const updatePassword = () => {
    form.put(route('user-password.update'), {
        errorBag: 'updatePassword',
        preserveScroll: true,
        onSuccess: () => form.reset(),
        onError: () => {
            if (form.errors.password) {
                form.reset('password', 'password_confirmation');
                passwordInput.value.focus();
            }

            if (form.errors.current_password) {
                form.reset('current_password');
                currentPasswordInput.value.focus();
            }
        },
    });
};

//function to convert unix timestamp
function convertTimestamp(timestamp) {
    var d = new Date(timestamp * 1000),	// Convert the passed timestamp to milliseconds
        yyyy = d.getFullYear(),
        mm = ('0' + (d.getMonth() + 1)).slice(-2),	// Months are zero based. Add leading 0.
        dd = ('0' + d.getDate()).slice(-2),			// Add leading 0.
        hh = d.getHours(),
        h = hh,
        min = ('0' + d.getMinutes()).slice(-2),		// Add leading 0.
        ampm = 'AM',
        time;

    if (hh > 12) {
        h = hh - 12;
        ampm = 'PM';
    } else if (hh === 12) {
        h = 12;
        ampm = 'PM';
    } else if (hh == 0) {
        h = 12;
    }

    // ie: 2013-02-18, 8:35 AM	
    time = yyyy + '-' + mm + '-' + dd + ', ' + h + ':' + min + ' ' + ampm;

    return time;
}

//function to convert date time to times ago
function timeAgo(time) {

    //if time is in unix timestamp format
    if (typeof time === 'number') {
        time = convertTimestamp(time);
    }

    //if time is in string format
    if (typeof time === 'string') {
        time = new Date(time);
    }

    //if time is in milliseconds format
    if (typeof time === 'object') {
        time = time;
    }

    var time_formats = [
        [60, 'seconds', 1], //60
        [120, '1 minute ago', '1 minute from now'], // 60*2
        [3600, 'minutes', 60], // 60*60, 60
        [7200, '1 hour ago', '1 hour from now'], // 60*60*2
        [86400, 'hours', 3600], // 60*60*24, 60*60
        [172800, 'Yesterday', 'Tomorrow'], // 60*60*24*2
        [604800, 'days', 86400], // 60*60*24*7, 60*60*24
        [1209600, 'Last week', 'Next week'], // 60*60*24*7*4*2
        [2419200, 'weeks', 604800], // 60*60*24*7*4, 60*60*24*7
        [4838400, 'Last month', 'Next month'], // 60*60*24*7*4*2
        [29030400, 'months', 2419200], // 60*60*24*7*4*12, 60*60*24*7*4
        [58060800, 'Last year', 'Next year'], // 60*60*24*7*4*12*2
        [2903040000, 'years', 29030400], // 60*60*24*7*4*12*100, 60*60*24*7*4*12
        [5806080000, 'Last century', 'Next century'], // 60*60*24*7*4*12*100*2
        [58060800000, 'centuries', 2903040000] // 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
    ];
    var seconds = (+new Date() - time) / 1000, //   60*60*24*7*4*12*100
        token = 'ago',
        list_choice = 1; // 1 is 'ago' and 2 is 'from now'

    if (seconds == 0) {
        return 'Just now' //just now
    }
    if (seconds < 0) { //if seconds is less than 0
        seconds = Math.abs(seconds);
        token = 'from now'; //set token to 'from now'
        list_choice = 2; //set list_choice to 2
    }
    var i = 0, format; //format is undefined
    while (format = time_formats[i++]) if (seconds < format[0]) { //if seconds is less than format[0]
        if (typeof format[2] == 'string')   //if format[2] is a string
            return format[list_choice]; //return format[list_choice]
        else
            return Math.floor(seconds / format[2]) + ' ' + format[1] + ' ' + token; //return seconds divided by format[2] and add format[1] and token
    }
    return time; //return time
}

//function to toggle password visibility
const togglePasswordShow = () => {
    const password = document.getElementById('password');
    const toggle = document.getElementById('passwordShowicon');

    if (password.type === 'password') {
        password.type = 'text';
        // toggle.classList.add('bx-hide');
        toggle.classList.add('bx-show');
    } else {
        password.type = 'password';
        // toggle.classList.add('bx-show');
        toggle.classList.remove('bx-show');
    }
};

//function to toggle password visibility
const toggleCurrentPasswordShow = () => {
    const current_password = document.getElementById('current_password');
    const toggle = document.getElementById('currentShowicon');

    if (current_password.type === 'password') {
        current_password.type = 'text';
        // toggle.classList.add('bx-hide');
        toggle.classList.add('bx-show');
    } else {
        current_password.type = 'password';
        // toggle.classList.add('bx-show');
        toggle.classList.remove('bx-show');
    }
};

//function to toggle password visibility
const toggleConfirmPasswordShow = () => {
    const password_confirmation = document.getElementById('password_confirmation');
    const toggle = document.getElementById('confirmShowicon');

    if (password_confirmation.type === 'password') {
        password_confirmation.type = 'text';
        // toggle.classList.add('bx-hide');
        toggle.classList.add('bx-show');
    } else {
        password_confirmation.type = 'password';
        // toggle.classList.add('bx-show');
        toggle.classList.remove('bx-show');
    }
};

</script>

<template>
    <AppLayout title="Profile" :year=year :user=user>
        <div class="container-xxl flex-grow-1 container-p-y">
            <h4 class="fw-bold py-3 mb-2">Account Settings</h4>
            <p class="mb-4">Update your account's profile information and email address.</p>

            <div class="row">
                <div class="col-md-12">
                    <ul class="nav nav-pills flex-column flex-md-row mb-3">
                        <li class="nav-item">
                            <Link class="nav-link" href="/user/profile"><i class="bx bx-user me-1"></i>
                            Account</Link>
                        </li>
                        <li class="nav-item">
                            <Link class="nav-link active" href="/users/security"><i class="bx bx-lock-alt me-1"></i>
                            Security</Link>
                        </li>
                    </ul>
                    <!-- Change Password -->
                    <div class="card mb-4">
                        <h5 class="card-header">Change Password</h5>
                        <div class="card-body">
                            <p>Ensure your account is using a long, random password to stay secure.</p>
                            <form @submit.prevent="updatePassword">
                                <div class="row">
                                    <div class="mb-3 col-md-6 form-password-toggle">
                                        <label class="form-label" for="current_password">Current Password</label>
                                        <div class="input-group input-group-merge">
                                            <input class="form-control" type="password" id="current_password"
                                                ref="currentPasswordInput" v-model="form.current_password"
                                                :class="{ 'is-invalid': form.errors.current_password }"
                                                placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;" />
                                            <span class="input-group-text cursor-pointer" id="form-alignment-password"
                                                @click="toggleCurrentPasswordShow"><i id="currentShowicon"
                                                    class="bx bx-hide"></i></span>
                                            <div v-if="form.errors.current_password" class="invalid-feedback">
                                                <div v-text="form.errors.current_password"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="mb-3 col-md-6 form-password-toggle">
                                        <label class="form-label" for="newPassword">New Password</label>
                                        <div class="input-group input-group-merge">
                                            <input class="form-control" type="password" id="password"
                                                ref="passwordInput" v-model="form.password"
                                                :class="{ 'is-invalid': form.errors.password }"
                                                placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;" />
                                            <span class="input-group-text cursor-pointer" id="form-alignment-password"
                                                @click="togglePasswordShow"><i id="passwordShowicon"
                                                    class="bx bx-hide"></i></span>
                                            <div v-if="form.errors.password" class="invalid-feedback">
                                                <div v-text="form.errors.password"></div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="mb-3 col-md-6 form-password-toggle">
                                        <label class="form-label" for="confirmPassword">Confirm New Password</label>
                                        <div class="input-group input-group-merge">
                                            <input class="form-control" type="password" id="password_confirmation"
                                                v-model="form.password_confirmation"
                                                :class="{ 'is-invalid': form.errors.password_confirmation }"
                                                placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;" />
                                            <span class="input-group-text cursor-pointer" id="form-alignment-password"
                                                @click="toggleConfirmPasswordShow"><i id="confirmShowicon"
                                                    class="bx bx-hide"></i></span>
                                            <div v-if="form.errors.password_confirmation" class="invalid-feedback">
                                                <div v-text="form.errors.password_confirmation"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 mb-4">
                                        <p class="fw-semibold mt-2">Password Requirements:</p>
                                        <ul class="ps-3 mb-0">
                                            <li class="mb-1">Minimum 8 characters long - the more, the better</li>
                                            <li class="mb-1">At least one lowercase & an uppercase character</li>
                                            <li>At least one number and a symbol character</li>
                                        </ul>
                                    </div>
                                    <div class="col-12 mt-1">
                                        <button type="submit" class="btn btn-success me-2"
                                            :class="{ 'opacity-25': form.processing }" :disabled="form.processing">Save
                                            changes</button>
                                        <span v-show="form.recentlySuccessful" class="mr-3">
                                            <span leave-active-class="transition ease-in duration-1000"
                                                leave-from-class="opacity-100" leave-to-class="opacity-0"
                                                class="text-secondary">
                                                <span class="badge bg-secondary">Changes Saved</span>
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <!--/ Change Password -->

                    <!-- Recent Devices -->
                    <div class="card mb-4">
                        <h5 class="card-header">Browser Sessions</h5>
                        <div class="m-4">
                            <p>Manage and log out your active sessions on other browsers and devices.</p>
                            If necessary, you may log out of all of your other browser sessions across all of your
                            devices. Some of
                            your recent sessions are listed below; however, this list may not be exhaustive. If you feel
                            your
                            account has been compromised, you should also update your password.

                        </div>

                        <div class="table-responsive">
                            <table class="table border-top">
                                <thead>
                                    <tr>
                                        <th class="text-truncate">Browser</th>
                                        <th class="text-truncate">Ip Address</th>
                                        <th class="text-truncate">Last Activity</th>
                                        <th class="text-truncate">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="session in props.sessions">
                                        <td class="text-truncate" style="max-width:500px;">
                                            <i class="bx bxl-windows text-info me-3"></i>
                                            <span class="fw-semibold">{{ session.user_agent }}</span>
                                        </td>
                                        <td class="text-truncate">{{ session.ip_address }}</td>
                                        <td class="text-truncate">{{ timeAgo(session.last_activity) }}

                                            <span v-if="session.id == currentSessionId" class="badge bg-success">This
                                                Device</span>
                                        </td>
                                        <td class="text-truncate">
                                            <span v-if="session.id == currentSessionId"></span>
                                            <Link v-else class="btn btn-outline-danger"
                                                :href="'/users/removeSession/' + session.id" preserve-scroll>
                                            Logout</Link>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </AppLayout>
</template>
